/**
 * Arabic for work the old boards raise and move, carried to the work order
 * register — what the shell says when the register answers.
 * Proposed; pending native aviation review.
 */
const ar: Record<string, string> = {
  "{ref} raised in the work order register.": "أُنشئ {ref} في سجل أوامر العمل.",
  "Nothing to move.": "لا شيء لنقله.",
  "This work order is not on the platform yet, so the change stays on this page.":
    "أمر العمل هذا ليس على المنصة بعد، لذا يبقى التغيير على هذه الصفحة فقط.",
  "The register can't move {ref} from {from} to {to}.": "لا يستطيع السجل نقل {ref} من «{from}» إلى «{to}».",
  "{ref} is now {status} in the work order register.": "أصبح {ref} الآن «{status}» في سجل أوامر العمل.",
  "{ref} was already {status} in the work order register.": "كان {ref} بالفعل «{status}» في سجل أوامر العمل.",
  /* where a board put the work, in a refusal */
  raised: "مُنشأ",
  "on hold": "معلّق",
};

export default ar;
